import * as React from "react";
import { useEffect } from "react";
import { Box, Grid } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useAppSelector, useAppDispatch } from "../../../redux/hooks";
import Carouselcomponent from "../../corousel/Carousel-component";
import { propertyImages } from "../../../redux/slices/propertyImagesSlice";
import { GenericToast } from "../../util/ToastMessage";
import { CommentKey } from "../../../constant";
import { dateTimeToDateFormat } from "../../util/valueFormatter";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";

import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
import "froala-editor/js/third_party/embedly.min.js";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/third_party/embedly.min.css";
import { getAbfStatusLogs } from "redux/slices/abfStatusSlice";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

export const SummaryInternationalDisplayForm = () => {
  const dispatch = useAppDispatch();

  const dapData: any = useAppSelector((state) => state.summary.internationalData);
  const comment = useAppSelector((state) => state.dapComments?.data).find(
    (x) => x.commentKey.toLowerCase() === CommentKey.SUMMARY_KEY.toLowerCase()
  );
  const errorStatus = useAppSelector((state) => ({
    loading: state.summary.loading,
    error: state.summary.error
  }));
  const portfolioInvestments = useAppSelector((state) => state.abfStatus.data);
    useEffect(() => {
      if (dapData?.investmentId && dapData?.budgetYear && dapData.investmentId.toLowerCase().includes("portfolio")) {
        dispatch(
          getAbfStatusLogs({
            investmentId: dapData.investmentId,
            budgetYear: Number(dapData.budgetYear),
          }),
        );
      }
    }, [dapData?.investmentId, dapData?.budgetYear, dispatch]);
  
  useEffect(() => {
    if (!dapData?.investmentId) return;
    
    const investmentIds = dapData.investmentId.toLowerCase().includes("portfolio")
      ? portfolioInvestments?.map(investment => investment.investmentId).filter(Boolean) || []
      : [dapData.investmentId];
    
    dispatch(propertyImages({ investmentIds }));
  }, [dapData?.investmentId, portfolioInvestments, dispatch]);


  return (
    <div className="container ">
      <Box sx={{ width: "100%" }}>
        <div className="data-content">
          <Box sx={{ flexGrow: 1 }} className="summary-form">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                {errorStatus.loading ? (
                  <Skeleton variant="rounded" width="100%" height={350} animation="wave" />
                ) : (
                  <Item>
                    <table className="summary-table">
                      <tr>
                        <th><b>ID:</b></th>
                        <td>{dapData?.investmentId}</td>
                      </tr>
                      <tr>
                        <th><b>Fund Name:</b></th>
                        <td>{dapData?.fundName}</td>
                      </tr>
                      <tr>
                        <th><b>City (check emea yardi, if not dealpath):</b></th>
                        <td>{dapData?.city}</td>
                      </tr>
                      <tr>
                        <th><b>Country:</b></th>
                        <td>{dapData?.country}</td>
                      </tr>
                      <tr>
                        <th><b>Date (first) acquired:</b></th>
                        <td>{dapData?.dateAcquired ? dateTimeToDateFormat(dapData?.dateAcquired) : ""}</td>
                      </tr>
                      <tr>
                        <th><b>Asset manager:</b></th>
                        <td>{dapData?.assetManager?.firstName} {dapData?.assetManager?.lastName}</td>
                      </tr>
                      <tr>
                        <th><b>Fund manager:</b></th>
                        <td>{dapData?.fundManager?.firstName} {dapData?.fundManager?.lastName}</td>
                      </tr>
                      <tr>
                        <th><b>Sector (Property Type):</b></th>
                        <td>{dapData?.sector}</td>
                      </tr>
                      <tr>
                        <th><b>Sub-sector (Property Sub-Type):</b></th>
                        <td>{dapData?.subSector}</td>
                      </tr>
                      <tr>
                        <th><b>Stranding Year, Carbon:</b></th>
                        <td>{dapData?.strandingYearCarbon}</td>
                      </tr>
                      <tr>
                        <th>&nbsp;</th>
                        <td>&nbsp;</td>
                      </tr>
                    </table>
                  </Item>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {errorStatus.loading ? (
                  <Skeleton variant="rounded" width="100%" height={350} animation="wave" />
                ) : (
                  <Item>
                    <table className="summary-table">
                      <tr>
                        <th><b>Ownership type:</b></th>
                        <td>{dapData?.ownershipType}</td>
                      </tr>
                      <tr>
                        <th><b>Fund ownership (%):</b></th>
                        <td>{dapData?.fundOwnership ? dapData?.fundOwnership.toFixed(2) : ""}</td>
                      </tr>
                      <tr>
                        <th><b>Currency :</b></th>
                        <td>{dapData?.currency}</td>
                      </tr>
                      <tr>
                        <th><b>Book Cost:</b></th>
                        <td>{dapData?.bookCostField}</td>
                      </tr>
                      <tr>
                        <th><b>Debt:</b></th>
                        <td>{dapData?.debt === "1" ? "Yes" : "No"}</td>
                      </tr>
                      <tr>
                        <th><b>Total CAPEX:</b></th>
                        <td>{dapData?.totalCapEx}</td>
                      </tr>
                      <tr>
                        <th><b>Special purpose vehicle:</b></th>
                        <td>{dapData?.specialPurposeVehicle}</td>
                      </tr>
                      <tr>
                        <th><b>JV Partner :</b></th>
                        <td>{dapData?.jvPartner}</td>
                      </tr>
                      <tr>
                        <th><b>Property managing agent:</b></th>
                        <td>{dapData?.propertyManagingAgent}</td>
                      </tr>
                      <tr>
                        <th><b>Operator:</b></th>
                        <td>{dapData?.operator}</td>
                      </tr>
                      <tr>
                        <th><b>Key PMA / operator contact:</b></th>
                        <td>{dapData?.keyPMAOperatorContact}</td>
                      </tr>
                    </table>
                  </Item>
                )}
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ flexGrow: 1 }} className="summary-property-section summary-form">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Item>
                  <h3 className="text-left pl-10">Property Images</h3>
                  <div className="clear"></div>
                  <Carouselcomponent />
                </Item>
              </Grid>
              <Grid item xs={12} md={6}>
                <Item>
                  <h3 className="text-left pl-10">Additional Property Description</h3>
                  <div className="clear"></div>
                  <div style={{ marginLeft: "12px" }}>
                    <FroalaEditorView model={comment?.commentText || ""} />
                  </div>
                </Item>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Box>
      {errorStatus.error && <GenericToast message={errorStatus.error} severity="error" />}
    </div>
  );
};
